// src/api/axiosConfig.js

import axios from 'axios';

// Assurez-vous que l'adresse IP est correcte
const API_URL = 'https://spmerchflow.com:8000';

const axiosInstance = axios.create({
  baseURL: API_URL,
});

// --- INTERCEPTEUR DE REQUÊTE ---
// Ajoute le token à chaque requête
axiosInstance.interceptors.request.use(
  (config) => {
    // 1. On récupère le token depuis le stockage local
    const token = localStorage.getItem('authToken');

    // 2. S'il existe, on le met dans l'en-tête (headers)
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`;
    }

    // 3. On retourne la configuration (avec ou sans token)
    return config;
  },
  (error) => {
    // Gérer une erreur de configuration de la requête
    return Promise.reject(error);
  }
);

// --- INTERCEPTEUR DE RÉPONSE ---
// Gère les erreurs d'authentification (token expiré)
axiosInstance.interceptors.response.use(
  (response) => {
    // Si la réponse est réussie, on la retourne telle quelle
    return response;
  },
  (error) => {
    // Si l'erreur est 401 (Unauthorized)
    if (error.response && error.response.status === 401) {
      console.warn('⚠️ Token expiré ou invalide. Redirection vers la page de connexion...');

      // Nettoyer le localStorage
      localStorage.removeItem('authToken');
      localStorage.removeItem('userRole');

      // Rediriger vers la page de connexion
      window.location.href = '/login';
    }

    return Promise.reject(error);
  }
);

export default axiosInstance;
